export default {
  title: '华大万物基地展示系统',
  description: '华大万物基地展示系统',
  iconfontUrl: '//at.alicdn.com/t/c/font_4819495_uummvcijle.js',
  appCode: 'hdww-pc',
};

export function isDev() {
  // console.log(import.meta.env);
  return import.meta.env.DEV;
}
